module.exports = __webpack_public_path__ + "img/0Q3A4612_L_BlackMatted.26da0e74.jpg";